var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{directives:[{name:"dbclick",rawName:"v-dbclick"}],staticClass:"copy-btn",attrs:{"type":_vm.buttonType},on:{"click":function($event){$event.stopPropagation();return _vm.handleCopyBtn.apply(null, arguments)}}},[_vm._v("复制")])}
var staticRenderFns = []

export { render, staticRenderFns }